import styled from "styled-components";
import icoBorra from "../../assets/simb-borra.png";
import icoFert from "../../assets/simb-baby.png";
import icoRelac from "../../assets/simb-hearth.png";

export const Container = styled.div<{ edit : boolean, fullSpace : boolean }>`
    display: flex;
    flex: 1;
    cursor: ${props => props.edit ? 'pointer' : 'inherit'};

    ${props => props.fullSpace && 'width: calc(100% - 4px)'};
    ${props => props.fullSpace && 'height: calc(100% - 4px)'};
    ${props => props.fullSpace && 'position: absolute'};
    ${props => props.fullSpace && 'top: 0'};
    ${props => props.fullSpace && 'left: 0'};
    ${props => props.fullSpace && 'margin: 2px'};

    div.regranull, div.regra, div.regran0{
        background: transparent;
        width: 21px;
        height: 20px;
        border: dashed 1px rgba(0,0,0,0.5);
        border-radius: 5px;
        opacity: 0.3;
        display: ${props => props.edit ? 'block' : 'none'};
        
        &::before{
            content: 'ADD';
            font-size: 0.49rem;                        
            display: flex;
            justify-content: center;
            align-items: center;
            align-content: center;
            flex:1;
            padding-top: 5px;
        }

        &:hover{
            opacity: 0.7;
            transition: 0.9s;
            background: var(--darkblue);
            color: #fff;
        }
    }
`
// simbolo da regra
export const Simbol = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    z-index: 2;
    min-height: 30px;

    div.regra1{
        background: var(--darkblue);
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        display: block;
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%);
    }
    div.regra2{
        background: url(${icoBorra}) no-repeat center center;
        width: 18px;
        height: 20px;
        display: block;
    }
    div.regra3{
        background: var(--darkblue);
        width: 0.95rem;
        height: 0.25rem;
        border-radius: 5px;        
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%);
        top: -3px;

        &::before{
            content: '.';
            background: var(--darkblue);
            width: 0.95rem;
            height: 0.25rem;
            border-radius: 5px;
            top: 6px;
            box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%); 
            font-size: 1px;
            display: block;
            position: absolute;
        }
    }
    div.regra4{
        background: var(--darkblue);
        width: 0.25rem;
        height: 0.90rem;
        border-radius: 5px;        
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%);
    }
    div.regra5{
        background: transparent;
        border: solid 2px var(--darkblue);
        width: 0.9rem;
        height: 0.9rem;
        border-radius: 50%;
        display: block;
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%);
    }
    div.regra6{ 
        display: flex;      
        flex: 1;
        justify-content: center;

        &::before{
            content: "✖";
            font-size: 1.1rem;
            text-shadow: 1px 1px 3px rgb(0 0 0 / 30%);
            font-weight: 900;
        }
    }
    div.regra7, div.regra8, div.regra9{ 
        display: flex;      
        flex: 1;
        justify-content: center;

        &::before{
            content: "1";
            font-family: 'Lilita One', Calibri, cursive;
            font-size: 0.9rem;
            text-shadow: 1px 1px 3px rgb(0 0 0 / 30%);
            font-weight: 900;
            font-style: italic;
            margin-right: 3px;
        }
    }
    div.regra8{ 

        &::before{
            content: "2";
        }
    }
    div.regra9{ 
        &::before{
            content: "3";
        }
    }

    

`

// Fertilidade
export const Fertilidade = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center; 
    z-index: 2;

    div.regra11{
        background: url(${icoFert}) no-repeat center center;
        width: 18px;
        height: 20px;
        display: block;
    }
`

// Selos
export const Selo = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;  
    
    z-index : 1;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    opacity: 0.85;

    div.regra1, div.regra2, div.regra3, div.regra4{
        background: #FF5050;
        //width: 0.9rem;
        //height: 0.9rem;
        //width: calc(200% + 9px);
        width: calc(100%);
        height: 34px;
        /*aspect-ratio: 1/1.1;*/
        border-radius: 4px;
        display: block;
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 30%);
        position: absolute;
        left: 0px;
    }
    div.regra2{
        background: #FFCE3C;
    }
    div.regra3{
        background: #00C382;
    }
    div.regra4{
        background: #f0ede7;
    }

    div.regranull{
        border: unset;
    }
    div.regranull::before{
        content: '';
    }

    .fullColor{
      position: absolute;
    }
    
`

// Relações
export const Relacao = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;   

    div.regra1{
        background: url(${icoRelac}) no-repeat center center;
        width: 18px;
        height: 20px;
        display: block;
    }
`

// RegraDia
export const RegraDia = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    z-index: 2;
    min-height: 30px;

    div.regra1, div.regra2, div.regra3, div.regra4{      
        display: flex;      
        flex: 1;
        justify-content: center;
        align-items: center;

        &::before{
            content: "R1";
            font-family: 'Roboto Condensed', Calibri, cursive;
            font-size: 0.85rem;
            text-shadow: 1px 1px 3px rgb(0 0 0 / 30%);
            font-weight: 400;
            font-style: italic;
            margin-right: 3px;
            
        }
    }
    div.regra2{ 

        &::before{
            content: "R2";
        }
    }
    div.regra3{ 
        &::before{
            content: "R3";
        }
    }
    div.regra4{ 
        &::before{
            content: "RA";
        }
    }
`